/**
 * Permissions-Konstanten: Bereiche, Stufen, Scope-Typen und Default-Map.
 * Aus Permissions.jsx extrahiert, um die Hauptdatei kompakt zu halten.
 */
import {
  Users, Lock, Briefcase, FileText, Settings, Shield,
  Calendar, Clock, Globe, Building, MapPin, User, Car, DoorOpen, FileEdit, Wrench,
} from 'lucide-react';

export const PERMISSION_AREAS = [
  { area: 'employees', label: 'Mitarbeiter', icon: Users, desc: 'Mitarbeiterdaten' },
  { area: 'vacations', label: 'Urlaub', icon: Calendar, desc: 'Urlaubsantraege' },
  { area: 'shifts', label: 'Einsatzplanung', icon: Briefcase, desc: 'Schichten und Planung' },
  { area: 'sensitive_data', label: 'Sensible Daten', icon: Lock, desc: 'Fuehrungszeugnis etc.' },
  { area: 'time_tracking', label: 'Zeiterfassung', icon: Clock, desc: 'Arbeitszeiten' },
  { area: 'absences', label: 'Abwesenheiten', icon: Calendar, desc: 'Krankheit, Elternzeit' },
  { area: 'documents', label: 'Dokumente', icon: FileText, desc: 'Vorlagen, Unterlagen' },
  { area: 'rooms', label: 'Raumverwaltung', icon: DoorOpen, desc: 'Raeume, Buchungen sowie Reinigung / Putzplan' },
  { area: 'facility', label: 'Haustechnik / Facility', icon: Wrench, desc: 'Facility-Meldungen, Tickets und Wartung' },
  { area: 'job_postings', label: 'Stellenausschreibungen', icon: FileEdit, desc: 'Stellen veroeffentlichen, bearbeiten und schliessen' },
  { area: 'settings', label: 'Einstellungen', icon: Settings, desc: 'Systemkonfiguration' },
  { area: 'compliance', label: 'Compliance', icon: Shield, desc: 'Massnahmen, Pruefungen' },
  { area: 'news', label: 'Neuigkeiten', icon: Briefcase, desc: 'Newsfeed / Schwarzes Brett' },
  { area: 'fleet', label: 'Fuhrpark', icon: Car, desc: 'Fahrzeugverwaltung, Halter, Reifen, Verlauf' },
];

export const LEVEL_ORDER = ['none', 'view', 'execute', 'edit'];

export const LEVEL_LABELS = {
  none: 'Kein Zugriff',
  view: 'Ansehen',
  execute: 'Ausfuehren',
  edit: 'Bearbeiten',
};

export const LEVEL_COLORS = {
  none: 'bg-gray-100 text-gray-500',
  view: 'bg-blue-100 text-blue-700',
  execute: 'bg-amber-100 text-amber-700',
  edit: 'bg-green-100 text-green-700',
};

export const SCOPE_TYPES = [
  { value: 'all', label: 'Alle Bereiche', icon: Globe, description: 'Zugriff auf alle Niederlassungen und Standorte' },
  { value: 'branch', label: 'Niederlassung', icon: Building, description: 'Auf bestimmte Niederlassungen beschraenkt' },
  { value: 'location', label: 'Standort', icon: MapPin, description: 'Auf bestimmte Standorte beschraenkt' },
  { value: 'own', label: 'Nur eigene Daten', icon: User, description: 'Nur Zugriff auf eigene Informationen' },
];

export const defaultPerms = () => {
  const p = {};
  PERMISSION_AREAS.forEach((a) => { p[a.area] = 'none'; });
  return p;
};
